import { createContext, useContext } from 'react';
import { ExaminersList, ExtendedExaminersList, MenuItemsConditions } from './ExaminersStructure.types';
import { ActionMenuItem } from '../ActionsMenu/ActionsMenu.types';

interface ExaminersTreeContextData {
  onActiveElementChange: (element: ExaminersList) => void;
  onClosedElementChange: (element: ExaminersList, isOpen?: boolean) => void;
  getMenuItemsConditions: (examiner: ExtendedExaminersList | null) => MenuItemsConditions;
  getMenuItems: (
    examiner: ExtendedExaminersList,
    menuItemsConditions: MenuItemsConditions,
    isExaminingTeamBlocked: boolean,
  ) => ActionMenuItem[];
}

export const ExaminersTreeContext = createContext<ExaminersTreeContextData | null>(null);

export const useExaminersTreeContext = () => {
  const value = useContext(ExaminersTreeContext);

  if (!value) {
    throw new Error('No ExaminersTreeContext');
  }

  return value;
};
